module.exports = __webpack_public_path__ + "e1dfeb618cdb817b00ff1ceb6324cda4.svg";